export default "__VITE_ASSET__Sk7O$XZe__";